import { ProjectAgentKeysPage } from "@/features/projects/project-agent-keys.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys",
)({
  component: ProjectAgentKeysPage,
});
